<div class="dialog-box">
  <div class="mat-dialog-title" mat-dialog-title>
      <div id="lblHeading">
          Message History
          <i class="fa fa-times-circle pull-right" (click)="togglePopupDialog()" aria-hidden="true"></i>
      </div>
  </div>
</div>
<div mat-dialog-content>
  <kendo-grid [kendoGridBinding]="historyList" class="eip-pb-20 k-resizable-grid" [sortable]="false" [resizable]="true" [reorderable]="false" [resizable]="true" [pageSize]="15" [pageable]="true" id="grvHistoryListt">
      <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{rowIndex+1}}
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Letter No" field="messageNumber" [width]="200">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.messageNumber}}" eipTooltipPosition="auto">{{dataItem.messageNumber}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Subject" field="messageSubject" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.messageSubject}}" eipTooltipPosition="auto">{{dataItem.messageSubject}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="From" field="from" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.from}}" eipTooltipPosition="auto">{{dataItem.from}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="To" field="to" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.to}}" eipTooltipPosition="auto">{{dataItem.to}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Sent On" field="sentOn" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.sentOn|date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.sentOn|date:'dd-MMM-yyyy'}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Respond On" field="respondOn" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.respondOn|date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.respondOn|date:'dd-MMM-yyyy'}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Date Of Response" field="responseDate" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.responseDate |date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.responseDate |date:'dd-MMM-yyyy'}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Status" field="status" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.status}}" eipTooltipPosition="auto">{{dataItem.status}}</span>
          </ng-template>
      </kendo-grid-column>
  </kendo-grid>
</div>